/**
 * Bilingual relative time used by comments and notifications:
 * الآن / منذ 5 د / منذ 3 س / أمس / منذ يومين / منذ 4 أيام, then the date.
 */
export const relativeTime = (iso: string, isRTL: boolean, now = Date.now()) => {
  const then = new Date(iso);
  const mins = Math.floor((now - then.getTime()) / 60000);
  if (mins < 1) return isRTL ? 'الآن' : 'just now';
  if (mins < 60) return isRTL ? `منذ ${mins} د` : `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return isRTL ? `منذ ${hours} س` : `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days === 1) return isRTL ? 'أمس' : 'yesterday';
  if (days < 7) {
    if (!isRTL) return `${days} days ago`;
    return days === 2 ? 'منذ يومين' : `منذ ${days} أيام`;
  }
  return then.toLocaleDateString(isRTL ? 'ar-SA' : 'en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const fullDate = (iso: string, isRTL: boolean) =>
  new Date(iso).toLocaleString(isRTL ? 'ar-SA' : 'en-US', {
    dateStyle: 'full',
    timeStyle: 'short',
  });
